import classNames from 'classnames';
import { Checkbox } from 'components/shared/Checkbox/Checkbox';
import type { FC, PropsWithChildren } from 'react';

export interface CellProps<T> {
  id: string;
  className?: string;
  value: T;
  onValueChange: (value: T) => void;
  isReadOnly?: boolean;
  isEdited?: boolean;
}

export const CheckBoxCell: FC<PropsWithChildren<CellProps<boolean>>> = ({
  value,
  onValueChange,
  id,
  isReadOnly,
  className,
  isEdited,
}) => {
  return (
    <div className={classNames('form-check justify-content-center', className)} data-e2e="switch-container">
      <Checkbox id={id} checked={value} disabled={isReadOnly} edited={isEdited} onChange={onValueChange} />
    </div>
  );
};
